import { render, staticRenderFns } from "./WidgetExample.vue?vue&type=template&id=2c00aec0&scoped=true&"
import script from "./WidgetExample.vue?vue&type=script&lang=js&"
export * from "./WidgetExample.vue?vue&type=script&lang=js&"
import style0 from "./WidgetExample.vue?vue&type=style&index=0&id=2c00aec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c00aec0",
  null
  
)

export default component.exports